import { isValidLandlineAreaCode, isValidMobileAreaCode } from '../api/validation.service';
import { patterns } from '../settings';

/*
 * mobile areaCode
 * */
export const isMobileAreaCode = (value: string) => patterns.AREA_CODE_MOBILE_STRING.test(value);
export const preventedIsValidMobileAreaCode = async (value: string) => {
    if (!isMobileAreaCode(value)) {
        return Promise.resolve(false);
    }

    return isValidMobileAreaCode(value);
};
/*
 * landline areaCode
 * */
export const isLandlineAreaCode = (value: string) => patterns.AREA_CODE_LANDLINE_STRING.test(value);
export const preventedIsValidLandlineAreaCode = async (value: string) => {
    if (!isLandlineAreaCode(value)) {
        return Promise.resolve(false);
    }

    return isValidLandlineAreaCode(value);
};
